import React from 'react';

import './style.scss';

class Spin extends React.PureComponent {

  render() {
    return (
      <div className='Modal_Overlay'>
        <div className='Spin'>
          <div className='lds-css ng-scope'>
            <div className='lds-spinner'>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Spin;